import { connect } from 'react-redux';
import Export from './export';
import { closePanel } from '../../actions/panel';
import { automaticPreview } from '../../selectors/preview';
import { workSizeDetails, totalPrice } from '../../selectors/work_sizes';
import {
  savePreview, showSharing, setLogo, resetLogo, publish
} from '../../actions/export';
import { updateAttributes } from '../../actions/canvas';

const mapStateToProps = (state) => {
  const {
    canvas: {
      name, description, currentColor, wallId, sharingUrl, currency
    },
    customImage, wallPaper, exporting,
    savingWall: { savingPictures }
  } = state;
  return {
    wallId,
    name,
    description,
    worksExtended: workSizeDetails(state),
    totalPrice: totalPrice(state),
    previewConfig: automaticPreview(state),
    currentColor,
    customImage,
    wallPaper,
    savingPictures,
    ...exporting,
    sharingUrl,
    currency
  };
};

export default connect(mapStateToProps, {
  closePanel, savePreview, showSharing, updateAttributes, setLogo, resetLogo, publish
})(Export);
